import { ListItemActions } from "./components/ListItemActions/list-item-actions";
import { SetupListItem } from "./components/SetupListItem/setup-list-item";
import { SetupListRoot } from "./setup-list";

const SetupList = {
  Root: SetupListRoot,
  Item: SetupListItem,
  Actions: ListItemActions,
};

export default SetupList;
